import { gql } from '@apollo/client';
import { CONSTRAINT_FIELDS_FRAGMENT } from './fragments';

/**
 * Constraint GraphQL Queries - 7 queries for Formula #4 support
 */

export const GET_CONSTRAINT = gql`
  ${CONSTRAINT_FIELDS_FRAGMENT}
  query GetConstraint($tenantId: String!, $constraintId: String!) {
    getConstraint(tenantId: $tenantId, constraintId: $constraintId) {
      ...ConstraintFields
    }
  }
`;

export const LIST_CONSTRAINTS = gql`
  ${CONSTRAINT_FIELDS_FRAGMENT}
  query ListConstraints($tenantId: String!, $limit: Int, $cursor: String) {
    listConstraints(tenantId: $tenantId, limit: $limit, cursor: $cursor) {
      items {
        ...ConstraintFields
      }
      total
      nextCursor
      hasMore
    }
  }
`;

export const GET_CONSTRAINTS_BY_TYPE = gql`
  ${CONSTRAINT_FIELDS_FRAGMENT}
  query GetConstraintsByType($tenantId: String!, $constraintType: GqlConstraintType!) {
    getConstraintsByType(tenantId: $tenantId, constraintType: $constraintType) {
      ...ConstraintFields
    }
  }
`;

export const GET_ACTIVE_CONSTRAINTS = gql`
  ${CONSTRAINT_FIELDS_FRAGMENT}
  query GetActiveConstraints($tenantId: String!) {
    getActiveConstraints(tenantId: $tenantId) {
      ...ConstraintFields
    }
  }
`;

export const GET_VIOLATED_CONSTRAINTS = gql`
  ${CONSTRAINT_FIELDS_FRAGMENT}
  query GetViolatedConstraints($tenantId: String!) {
    getViolatedConstraints(tenantId: $tenantId) {
      ...ConstraintFields
    }
  }
`;

export const GET_CONSTRAINTS_BY_ENTITY = gql`
  ${CONSTRAINT_FIELDS_FRAGMENT}
  query GetConstraintsByEntity($tenantId: String!, $entityType: String!, $entityId: String!) {
    getConstraintsByEntity(tenantId: $tenantId, entityType: $entityType, entityId: $entityId) {
      ...ConstraintFields
    }
  }
`;

export const CHECK_CONSTRAINT = gql`
  query CheckConstraint($tenantId: String!, $constraintId: String!, $value: Float!) {
    checkConstraint(tenantId: $tenantId, constraintId: $constraintId, value: $value)
  }
`;
